import { useState, useEffect } from "react";
import AdminImg from "../../../../assets/admin.png";
import EditYourProfile from "../../../../components/EditYourProfile";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useProfile } from "../../../../context/ProfileContext";
import { useMemo } from "react";
import { Pencil, Trash2 } from "lucide-react";
import EditResearcherProfile from "./EditResearcherProfile";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const ResearcherProfile = () => {
  const {
    profileId: contextId,
  } = useProfile();
  const { setProfileId } = useProfile();
  const { userId: id } = useParams();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [editMode, setEditMode] = useState("fullProfile");
  const [profile, setProfile] = useState(null);
  const [apiError, setApiError] = useState("");
  const [researcher, setResearcher] = useState(null);
  const [open, setOpen] = useState(false);
  // console.log("The researcher is:",researcher)
  const profileId = id || contextId;
  const isYourOwnProfile = useMemo(() => {
    if (profileId == null || contextId == null) return false;
    return Number(profileId) === Number(contextId);
  }, [profileId, contextId])

  const handleCoverUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("cover_image", file);
    try {
      await axios.post(
        `${BASE_URL}/user/profile/profile-cover-image/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        }
      );
      toast.success("Cover image updated!");
      fetchProfile();
    } catch (error) {
      toast.error("Failed to upload cover image.");
      console.log("Cover image upload error:", error);
    }
  };
  const fetchProfile = async () => {
    // if (!profileId) {
    //   console.warn("Profile ID not ready yet");
    //   return;
    // }

    setApiError("");
    try {
      let url;
      // console.log("isYourOwnProfile: ", isYourOwnProfile);

      if (!id) {
        url = `${BASE_URL}/user/profile/create-profile`;
      } else {
        const fetchId = id || contextId;
        if (!fetchId) throw new Error("No ID found for profile");
        url = `${BASE_URL}/user/profile/all-profiles?id=${fetchId}`;
      }

      const res = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      });

      const data = await res.json();
      if (!res.ok)
        throw new Error(
          data.message || data.error || "Failed to fetch profile"
        );

      setProfile(data.data);
    } catch (error) {
      setApiError(error.message);
    } finally {
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [profileId]);
  const fetchResearcher = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/marketplace/researcher/me/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      });
      // Entire researcher object
      setResearcher(response.data.researcher);
    } catch (err) {
      console.log("Error fetching researcher data:", err);
    }
  };
  useEffect(() => {


    fetchResearcher();
  }, []);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });

        const data = await res.json();
        if (res.ok) {
          setProfileId(data.data?.id);
        } else {
          console.error("Profile fetch failed");
        }
      } catch (error) {
        console.error("Error fetching profile:", error.message);
      }
    };

    fetchProfile();
  }, []);



  return (
    <>
      <div className="relative max-w-full">
        <div style={{
          backgroundImage: "url('../../../assets/backgroundvector.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}>
          {apiError ? (
            <p className="text-red-500 text-center py-4">{apiError}</p>
          ) : profile ? (
            <>
              <div className="w-full max-w-6xl py-5 pb-0 mx-auto mt-0 flex flex-col relative">
                {/* Cover Photo */}
                <div className="w-full h-[250px] mb-[-105px] rounded-xl overflow-hidden relative">
                  {!id && (
                    <div className="absolute top-4 right-4">
                      <label
                        htmlFor="cover-upload"
                        className="w-12 h-12 bg-white/80 backdrop-blur-sm rounded-xl flex justify-center items-center cursor-pointer hover:bg-white hover:shadow-md transition-all border border-white/50"
                      >
                        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                        </div>
                      </label>
                      <input
                        type="file"
                        id="cover-upload"
                        className="hidden"
                        accept="image/*"
                        onChange={handleCoverUpload}
                      />
                    </div>
                  )}
                  <img
                    src={profile.cover_image || AdminImg}
                    alt="User profile"
                    className="w-full h-full object-cover object-center"
                  />
                </div>

                <div className="w-full max-w-6xl py-5 pb-0 mx-auto mt-0 flex flex-col relative">
                  {/* Profile Picture */}
                  <div className="flex relative pl-6 w-full max-w-fit mb-[-65px]">
                    <div className="relative">
                      {profile?.profile_picture ? (
                        <img
                          src={profile.profile_picture}
                          alt="User profile"
                          className="w-[130px] h-[130px] rounded-full object-cover border-4 border-white shadow-lg"
                        />
                      ) : (
                        <div className="w-[130px] h-[130px] rounded-2xl bg-[#e8f0f7] border-4 border-white shadow-lg flex items-center justify-center">
                          <svg className="w-12 h-12 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                          </svg>
                        </div>
                      )}
                      <div className="absolute -bottom-[-15px] -right-2 w-6 h-6 bg-green-500 rounded-full border-2 border-white"></div>
                    </div>
                    <h2 className="ml-4 mt-20 text-xl font-semibold text-gray-900">{profile.name}</h2>
                  </div>

                  {/* Profile Info */}
                  <div className="flex flex-col pl-7 w-full">
                    {isEditOpen && isYourOwnProfile && (
                      <>
                        <div className="fixed inset-0 bg-black/50 z-[1000]"></div>
                        <div className="fixed inset-0 z-[1010] flex items-center justify-center p-4">
                          <div className="bg-white w-full max-w-2xl max-h-[90vh] overflow-auto rounded-xl py-4">
                            <EditYourProfile
                              onClose={() => { setIsEditOpen(false); fetchProfile(); }}
                              mode={editMode}
                            />
                          </div>
                        </div>
                      </>
                    )}

                    <div >
                      <div className="flex items-center justify-end w-full mb-4">

                        <div className="flex items-center gap-3">
                          {!id && (
                            <button
                              className="w-10 h-10 flex items-center justify-center bg-white border border-gray-300 text-gray-700 rounded-xl hover:border-[#0f6abf] hover:text-[#0f6abf] transition-all"
                              onClick={() => {
                                setEditMode("fullProfile");
                                setIsEditOpen(true);
                              }}
                            >
                              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                              </svg>
                            </button>
                          )}

                        </div>
                      </div>

                      {profile.research_areas && (
                        <div className="mt-8 flex flex-wrap gap-2 mb-6">
                          {profile.research_areas.split(',').slice(0, 3).map((area, index) => (
                            <span
                              key={index}
                              className="text-xs px-3 py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-lg font-medium"
                            >
                              {area.trim()}
                            </span>
                          ))}
                        </div>
                      )}

                      {/* Profile Details Card */}
                      <div className="w-full mt-6">
                        <div className="bg-[#e8f0f7] rounded-2xl p-6 space-y-4">
                          {profile.degree && (
                            <div className="flex items-center gap-2">
                              <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                              <p className="text-base font-semibold text-[#0f6abf]">{profile.degree}</p>
                            </div>
                          )}

                          {profile.primary_affiliation && (
                            <div className="flex items-center gap-2">
                              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                              </svg>
                              <p className="text-sm text-gray-700">{profile.primary_affiliation}</p>
                            </div>
                          )}

                          {profile.current_activity && (
                            <div className="flex items-center gap-2">
                              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                              <p className="text-sm text-gray-700">{profile.current_activity}</p>
                            </div>
                          )}

                          {profile.bio && (
                            <div className="pt-4 mt-4 border-t border-gray-300">
                              <div className="flex items-center gap-2 mb-3">
                                <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                                <h4 className="text-sm font-semibold text-gray-900">About</h4>
                              </div>
                              <p className="text-sm text-gray-700 leading-relaxed">{profile.bio}</p>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Teacher Info Section */}

                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>

        {/* Tabs Navigation */}
        {researcher && (

            <div className="w-full max-w-6xl p-2 md:p-6 mx-auto bg-white flex flex-col gap-6 rounded-b-2xl">
              <div className="mt-6">
                <div className="flex items-center justify-between gap-4 mb-6">

                  {/* Left title section */}
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                      <svg
                        className="w-5 h-5 text-[#0f6abf]"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                        />
                      </svg>
                    </div>

                    <div>
                      <h1 className="text-lg font-semibold text-gray-900">
                        Your Researcher Info
                      </h1>
                      <p className="text-sm text-gray-500">
                        Your teacher information is displayed here. You can manage and update your profile whenever necessary.
                      </p>
                    </div>
                  </div>

                  {/* Edit + Delete icons */}
                  <div className="flex gap-2">
                    <button onClick={() => setOpen(true)} className="w-10 h-10 flex items-center justify-center bg-white border border-gray-300 rounded-xl hover:border-[#0f6abf] hover:text-[#0f6abf] transition-colors">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    {/* <button className="w-10 h-10 flex items-center justify-center bg-white border border-gray-300 rounded-xl hover:border-red-500 hover:text-red-500 transition-colors">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button> */}
                  </div>

                </div>
              </div>

              {/* Content Section */}
              <div className="bg-gray-50 rounded-xl p-2 md:p-6">
                <div className="w-full max-w-xl bg-white border border-gray-200 rounded-xl p-6 space-y-6">

                  {/* Research Details */}
                  <div className="space-y-4">
                    <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl">
                      <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                        <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">Research Type</p>
                        <p className="text-sm font-medium text-gray-900">
                          {researcher.answers.research_type &&
                            researcher.answers.research_type.charAt(0).toUpperCase() +
                            researcher.answers.research_type.slice(1)
                          }

                        </p>
                      </div>
                    </div>

                    <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl">
                      <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                        <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">Active Project</p>
                        <span className={`text-sm font-medium ${researcher.answers.has_active_project ? 'text-green-600' : 'text-gray-900'
                          }`}>
                          {researcher.answers.has_active_project ? "Yes" : "No"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Research Interests */}
                  <div>
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                      <p className="text-sm font-semibold text-gray-900">
                        Research Interests
                      </p>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {researcher.answers.research_interests
                        .split(",")
                        .map((interest, index) => (
                          <span
                            key={index}
                            className="px-3 py-1.5 text-xs font-medium rounded-lg bg-[#e8f0f7] text-[#0f6abf]"
                          >
                            {interest.trim()}
                          </span>
                        ))}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          )}
        </div>
        <EditResearcherProfile open={open} setOpen={setOpen} fetchResearcher={fetchResearcher} />
    </>
  );
};

export default ResearcherProfile;
